/**
 * The vocabulary the whole platform is written in.
 *
 * A field is defined once in the library and reused by any number of products.
 * A product is a *selection* of library fields, arranged and constrained -
 * never a redefinition of them. Everything downstream (the API, the form
 * renderer, validation) reads these shapes and nothing else, which is why they
 * live in a package both sides import rather than being declared twice.
 */
/** What a field holds. The renderer picks a control from this, and the
 *  compiler picks a JSON Schema fragment from it, so the two cannot disagree. */
export const DATA_TYPES = [
    "text",
    "long_text",
    "integer",
    "decimal",
    "money",
    "percent",
    "boolean",
    "date",
    "choice",
    "multi_choice",
    "email",
    "phone",
];
/** Types whose answer is a number once parsed. */
export const NUMERIC_TYPES = ["integer", "decimal", "money", "percent"];
/** Types that draw their answers from a value domain. */
export const DOMAIN_TYPES = ["choice", "multi_choice"];
/** Operators that take no right-hand value, so the editor hides the value box. */
export const NO_VALUE_OPERATORS = ["is_blank", "is_present"];
/** Operators whose right-hand side is a list. */
export const LIST_OPERATORS = ["in", "not_in"];
//# sourceMappingURL=types.js.map